module.exports = __webpack_public_path__ + "static/img/2.8ce52a5.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/VascularSystem/Meeting602/images/2.png
// module id = cz4y
// module chunks = 4